import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router'
import { useHomeStore } from '../../store/useHomeStore'
import Loader from '../../Components/Loader'

const MarketArea = () => {
    const navigate = useNavigate()
    let [loading, setLoading] = useState(false)
    let { marketArea, postMarketArea } = useHomeStore()

    const [data, setData] = useState({
        subTitle: '',
        title: '',
        description: '',
    });

    const handleSubmit = async () => {
        setLoading(true)
        await postMarketArea(data)
        setLoading(false)
    }

    const getImageSrc = (img) => {
        if (!img) return null;
        if (typeof img === "string") {
            return img;
        }
        return URL.createObjectURL(img);
    };

    useEffect(() => {
        setData({
            subTitle: marketArea?.subTitle || '',
            title: marketArea?.title || '',
            description: marketArea?.description || '',
        })
    }, [marketArea])

    return (
        <div id="banner-section" className="bg-white rounded-md shadow-sm border border-neutral-200 mb-9 overflow-hidden" >
            <div className="px-6 py-4 border-b border-neutral-200 bg-neutral-50">
                <h3>Market Area Section</h3>
            </div>
            <Loader loading={loading}>
                <div className="p-6">
                    <div className="grid grid-cols-1 gap-6">
                        <div>
                            <label className="block text-sm text-neutral-700 mb-2">Title</label>
                            <input
                                type="text"
                                value={data?.title}
                                onChange={(e) => setData({ ...data, title: e.target.value })}
                                className="w-full p-3 border border-neutral-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-neutral-400 mb-4"
                            />

                            <label className="block text-sm text-neutral-700 mb-2">Subtitle</label>
                            <input type="text"
                                value={data?.subTitle}
                                onChange={(e) => setData({ ...data, subTitle: e.target.value })}
                                className="w-full p-3 border border-neutral-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-neutral-400 mb-4"
                            />

                        </div>
                    </div>
                    <div>
                        <label className="block text-sm text-neutral-700 mb-2">Description</label>
                        <div>
                            <textarea
                                rows="4"
                                value={data?.description}
                                onChange={(e) =>
                                    setData({ ...data, description: e.target.value })
                                }
                                className="w-full px-3 py-2 border border-neutral-300 rounded-md focus:outline-none focus:ring-2 focus:ring-neutral-400"
                            />
                        </div>
                    </div>
                </div>
            </Loader>
            <div className="flex justify-end space-x-3 p-3">
                <button className="px-4 py-2 border border-neutral-300 text-neutral-700 rounded-md"
                    onClick={() => navigate(-1)}
                >Cancel</button>
                <button
                    className="px-4 py-2 bg-neutral-900 text-white rounded-md"
                    onClick={() => handleSubmit()}
                >
                    Save Market Area section
                </button>
            </div>
        </div>
    )
}

export default MarketArea
